import { useEffect, useState } from "react";

export type Location = {
  latitude: number,
  longitude: number,
}

export type PositionState =
  /** 成功获取 */
  | 'granted'
  /** 被拒绝 */
  | 'denied'
  /** 默认状态 */
  | 'prompt';

export type IUsePosition = {
  /**
   * 通过的回调
   */
  onGranted?: <TGrantedParam>(params?: TGrantedParam) => void,

  /**
   * 拒绝的回调
   */
  onDenied?: () => void,

  /**
   * 初始化是否需要获取地址
   */
  isInit?: boolean
} | undefined

const usePosition = (props?: IUsePosition) => {

  const onDenied = props?.onDenied;
  const onGranted = props?.onGranted;
  const isInit = props?.isInit;

  const [positionState, setPositionState] = useState<PositionState>('prompt');
  const [_location, setLocation] = useState<Location | null>(null);

  /** 访问位置权限 */
  const handlePermissionChange = (permissionStatus: PermissionStatus) => {
    setPositionState(permissionStatus.state as PermissionState);
    if (permissionStatus.state === 'granted') {
      navigator.geolocation.getCurrentPosition((pos) => {
        const { latitude, longitude } = pos.coords;
        setLocation({ latitude, longitude });
        onGranted?.({ latitude, longitude, ...pos });
      }, (err) => {
        console.error('(没有获取到位置), Error getting geolocation:', err);
      });
    // 询问时被拒绝
    } else if (permissionStatus.state === 'denied') {
      console.log('访问时被拒绝')
      onDenied?.();
    }
  };

  /** 请求当前位置访问权限 */
  const queryPosition = async () => {
    try {
      const positionStatus = await navigator.permissions.query({ name: 'geolocation' } as PermissionDescriptor);
      handlePermissionChange(positionStatus);
      positionStatus.onchange = () => handlePermissionChange(positionStatus);
    }
    catch (error) {
      console.error('(没有开启访问权限), Error querying permissions:', error)
    }
  }

  useEffect(() => {
    // 浏览器不兼容
    if (
      !('permissions' in navigator)
      || !('geolocation' in navigator)
    ) {
      return
    }

    if (!isInit) return
    
    queryPosition();
  }, [onGranted, onDenied])

  return {
    /** 
     * 定位状态: 成功 ｜ 拒绝 ｜ 默认 
     */
    positionState,

    /**
     * 当前位置信息
     */
    _location,

    /** 
     * 发送当前位置访问
     */
    queryPosition,

    /**
     * 访问位置信息
     */
    handlePermissionChange
  }
}

export default usePosition;
